var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"travel-radar-legend"},_vm._l((_vm.legend),function(item,index){return _c('div',{key:index,staticClass:"travel-radar-legend__item"},[_c('div',{staticClass:"travel-radar-legend__item__image"},[_c('img',{attrs:{"src":item.image,"alt":item.label}})]),_c('div',{staticClass:"black copy"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }